import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Image from '../ContentfulImage';
import media from '../../styles/media.style';
import Section from '../Section';

const Images = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const Item = styled.div`
  width: 100%;

  ${media.tabletP`
    width: 50%;
  `};

  ${media.tabletL`
    width: calc(100% / 3);
  `};
`;

const GallerySection = ({ entryId, images }) => (
  <Section id={entryId} options={{ inner: { locked: true, style: { backgroundColor: '#e0e0e0' } } }}>
    <Images>
      {images &&
        images.map(image => (
          <Item key={image.entryId}>
            <Image src={image.image} options={{ aspectRatio: 1, w: '100%', objectFit: 'cover' }} />
          </Item>
        ))}
    </Images>
  </Section>
);

GallerySection.defaultProps = {
  entryId: undefined,
  images: undefined,
};

GallerySection.propTypes = {
  entryId: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape()),
};

export default GallerySection;



// WEBPACK FOOTER //
// ./src/components/Article/GallerySection.js